import React from 'react';
import Skeleton from 'react-loading-skeleton';
import S from './BannerSlider.module.scss';
export const BannerSliderSkeleton = () => {
  return <Skeleton className={S.skeleton} data-sentry-element="Skeleton" data-sentry-component="BannerSliderSkeleton" data-sentry-source-file="BannerSliderSkeleton.tsx" />;
};